var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleFixedBox',_vm._b({},'CycleFixedBox',_vm.componentData,false),_vm._l((_vm.jssFixedBox),function(comp,index){return _c(comp,{key:`fixedComponent${index}`,tag:"component"})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }